import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=0efe730a&scoped=true"
import script from "./StudentCourse.vue?vue&type=script&lang=js"
export * from "./StudentCourse.vue?vue&type=script&lang=js"
import style0 from "./StudentCourse.vue?vue&type=style&index=0&id=0efe730a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe730a",
  null
  
)

export default component.exports